module.exports = __webpack_public_path__ + "417504ba2f67f846f8293318d899e803.ttf";